import { render } from "./CertificationsDetailsPage.vue?vue&type=template&id=fd659bde&scoped=true&ts=true"
import script from "./CertificationsDetailsPage.vue?vue&type=script&lang=ts"
export * from "./CertificationsDetailsPage.vue?vue&type=script&lang=ts"

import "./CertificationsDetailsPage.vue?vue&type=style&index=0&id=fd659bde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd659bde"]])

export default __exports__